import OutpatientBenefitsStep from "components/steps/OutpatientBenefitsStep";

const FavPlanOutpatientBenefitsStep = () => <OutpatientBenefitsStep />;

export default FavPlanOutpatientBenefitsStep;
